import { post } from '@/request/racmBlockRequest';

let basePath = '/port/qflw';

export function superviseSave(params, vcode) {
  return post(basePath + '/supervise/add?vcode=' + vcode, params);
}

export function thumbSave(params, vcode) {
  return post(basePath + '/thumb/add?vcode=' + vcode, params);
}

export function sms(mobile) {
  return post(basePath + '/sms', mobile);
}
